module.exports = "<!-- Content Wide -->\n<section class=\"container-fluid\" style=\"padding: 0px !important\">\n  <carousel></carousel>\n</section>\n\n<div class=\"beta\">\n  <page [page_id]=\"'beta'\" [show_title]=\"false\"></page>\n</div>\n\n<highlights></highlights>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Templates/home.component.html
// module id = ./src/app/Templates/home.component.html
// module chunks = main